export default "__VITE_ASSET__e5WmEVq2__"